// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3Y9K0";
var _3 = "container_row-1eYnn";
var _4 = "container_col-V7qd6";
var _5 = "wrapper-15h6x";
var _6 = "day-2FCgS";
var _7 = "day_dow-Cranl";
var _8 = "nav-3fD00";
var _9 = "label-1i1cI";
var _a = "arrows-sxSht";
var _b = "arrow_next-3-t0P";
var _c = "arrow_prev-3BqC4";
export { _1 as "__esModule", _2 as "container", _3 as "container_row", _4 as "container_col", _5 as "wrapper", _6 as "day", _7 as "day_dow", _8 as "nav", _9 as "label", _a as "arrows", _b as "arrow_next", _c as "arrow_prev" }
export default { "__esModule": _1, "container": _2, "container_row": _3, "container_col": _4, "wrapper": _5, "day": _6, "day_dow": _7, "nav": _8, "label": _9, "arrows": _a, "arrow_next": _b, "arrow_prev": _c }
